"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentCardCms = void 0;
var PaymentCardCms = /** @class */ (function () {
    function PaymentCardCms() {
        this.nortonSSLSiteLabel = "Click to Verify - This site has chosen an SSL Certificate to improve Web site security";
        this.paymentMethodLabel = 'Payment method';
        this.cardNumberLabel = 'Card number';
        this.acceptedCardsInputBoxTooltip = 'Accepted cards';
        this.acceptedCardImageAltLabel = 'We accept Visa, MasterCard, American Express, ' +
            'Discover and Diner\'s Club International';
        this.acceptedCardMobileImageLinkUrlPath = '/idpassets/buy/images/creditcards@2x.png';
        this.acceptedCardImageLinkUrlPath = '/idpassets/buy/images/creditcards.png';
        this.paymentTenderUrl = '/scmsassets/buy_flow/wireless/postpaid/payment-tenders-with-ach.png';
        this.paymentTenderUrlWithApplePay = '/scmsassets/buy_flow/internet/payment-tenders-with-applepay-ach.png';
        this.zipCodeError = "Your card's ZIP Code is invalid";
        this.expirationDateLabel = 'Expiration date';
        this.expirationMonthLabel = 'Expiration Month';
        this.expirationYearLabel = 'Expiration Year';
        this.securityCodeLabel = 'Security code';
        this.securityPopUpInputBoxToolTipCards = 'Visa, MasterCard, or Discover';
        this.securityPopUpInputBoxToolTipMobileImage = '/idpassets/buy/images/visa_security@2x.png';
        this.securityPopUpInputBoxToolTipImage = '/idpassets/buy/images/visa_security.png';
        this.securityPopUpInputBoxToolTipCaption = "The 3-digit CVC security code is on the back of your card, right after the credit card number.";
        this.securityPopUpAmexCardInputBoxToolTip = 'American Express';
        this.securityPopUpAmexCardInputBoxToolTipMobileImage = '/idpassets/buy/images/amex_security@2x.png';
        this.securityPopUpAmexCardInputBoxToolTipImage = '/idpassets/buy/images/amex_security.png';
        this.securityPopUpAmexCardInputBoxToolTipCaption = "The 4-digit CVC security code is on the front of the card.";
        this.billingZipLabel = 'Billing ZIP Code';
        this.nameOnCardLabel = 'Name on card';
        this.expiryDateErrTxt = "Cannot be expired i.e. expiration month/year cannot be equal or prior to current month or year";
        this.cardNumberErrTxt = 'Enter a valid card number';
        this.secCodeErrTxt = 'Code is invalid';
        this.secCodeTooshortErrTxt = 'Code is too short';
        this.invalidZipCodeErrTxt = 'ZIP Code is invalid';
        this.zipCodeMisMatchErrTxt = 'Card\'s ZIP must match your billing address';
        this.fullNameErrTxt = 'Enter your full name';
        this.paymentMethodDropdownOptionOne = 'Debit or credit card';
        this.paymentMethodDropdownOptionTwo = 'AT&T Gift Card or promotion card';
        this.paypalInstructions = 'Select the <strong>Pay with PayPal</strong> button to sign in to PayPal and confirm your payment.';
        this.paypalEditLabel = 'To edit your PayPal info, please ';
        this.paypalEditLinkLabel = 'continue to PayPal.';
        this.paymentStoreProfileText = 'Store my payment method for future payments or purchases';
        this.paymentStoreProfileAutoPayText = 'Store my payment method for future purchases';
        this.cardInformationLabel = 'Card information';
        this.cardInformationPlaceholderLabel = 'Debit or credit card number';
        this.visaCardLabel = 'Visa';
        this.mastercardLabel = 'Mastercard';
        this.discoverCardLabel = 'Discover';
        this.amexCardLabel = 'American Express';
        this.cardExpirationLabel = 'EXPIRATION';
        this.cardExpirationPlaceholderLabel = 'mm/yy';
        this.singleCardNumberLabel = 'CARD NUMBER';
        this.cardCVVLabel = 'CVV';
        this.cardZipCodeLabel = 'ZIP CODE';
        this.snagApplePayMessage = 'We hit a snag connecting to Apple Pay. Select the <strong>Buy with Apple Pay</strong> button again or change your payment method.';
        this.secCodeReEnterMessage = 'Re-enter your security code';
        this.numbersOnlyErrorText = 'Restrict to numbers only';
        this.expirationVaildityErrorMsg = 'Enter a valid Expiration date';
        this.expirationDatePlaceHolder = 'mm/yy';
        this.autoPayDiscountContent = 'Save $[X]/mo. when you use a [Y].';
    }
    return PaymentCardCms;
}());
exports.PaymentCardCms = PaymentCardCms;
//# sourceMappingURL=PaymentCard.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/PaymentCard/PaymentCard.cms.js
// module id = 2026
// module chunks = 8